import React from "react";

import { Typography } from "@mui/material";

import { Theme } from "../../../../Style/Theme";
import { CustomSpinnerType1 } from "../../Spinner/CustomSpinnerType1/CustomSpinnerType1";

export const Text = ({ text, icon, color, onClick }) => {
  return (
    <WrapText isIcon={icon ? true : false} onClick={onClick}>
      {icon}
      <Typography
        fontWeight={400}
        fontSize={"13px"}
        fontStyle={"normal"}
        lineHeight={"18px"}
        letterSpacing={"-0.078px"}
        color={color || Theme.palette.text.grayDark}
        textTransform={"none"}
      >
        {text}
      </Typography>
    </WrapText>
  );
};
export const Text1 = ({ text, icon, color }) => {
  return (
    <WrapText isIcon={icon ? true : false}>
      {icon}
      <Typography
        fontWeight={400}
        fontSize={"12px"}
        fontStyle={"normal"}
        lineHeight={"16px"}
        color={color || Theme.palette.text.grayDark}
      >
        {text}
      </Typography>
    </WrapText>
  );
};

export const TextLink = ({ text, icon, color, onClick, loading }) => {
  return (
    <WrapText isIcon={icon ? true : false} onClick={onClick} loading={loading}>
      {icon}
      <Typography
        fontWeight={400}
        fontSize={"15px"}
        fontStyle={"normal"}
        lineHeight={"20px"}
        letterSpacing={"-0.24px"}
        color={color || Theme.palette.text.blue}
        style={{
          cursor: onClick && "pointer",
        }}
      >
        {loading ? <CustomSpinnerType1 size={20} /> : text}
      </Typography>
    </WrapText>
  );
};

export const Text2 = ({ text, icon, color }) => {
  return (
    <WrapText isIcon={icon ? true : false}>
      {icon}
      <Typography
        fontWeight={600}
        fontSize={"11px"}
        fontStyle={"normal"}
        lineHeight={"13px"}
        letterSpacing={"0.06pxx"}
        color={color || Theme.palette.text.grayDark}
      >
        {text}
      </Typography>
    </WrapText>
  );
};

export const Text3 = ({ text, icon, color }) => {
  return (
    <WrapText isIcon={icon ? true : false}>
      {icon}
      <Typography
        fontWeight={300}
        fontSize={"10px"}
        fontStyle={"normal"}
        lineHeight={"13px"}
        letterSpacing={"0.06pxx"}
        color={color || Theme.palette.text.grayDark}
      >
        {text}
      </Typography>
    </WrapText>
  );
};

export const Text4 = ({ text, icon, color }) => {
  return (
    <WrapText isIcon={icon ? true : false}>
      {icon}
      <Typography
        fontWeight={400}
        fontSize={"8px"}
        lineHeight={"13px"}
        color={color || Theme.palette.text.grayLight}
      >
        {text}
      </Typography>
    </WrapText>
  );
};
export const Text5 = ({ text, icon, color }) => {
  return (
    <WrapText isIcon={icon ? true : false}>
      {icon}
      <Typography
        fontWeight={400}
        fontSize={"15px"}
        lineHeight={"20px"}
        color={color || Theme.palette.text.grayLight}
      >
        {text}
      </Typography>
    </WrapText>
  );
};

export const Text6 = ({ text, icon, color }) => {
  return (
    <WrapText isIcon={icon ? true : false}>
      {icon}
      <Typography
        fontWeight={600}
        fontSize={"11px"}
        fontStyle={"normal"}
        lineHeight={"13px"}
        letterSpacing={"0.07pxx"}
        color={color || Theme.palette.text.grayLight}
      >
        {text}
      </Typography>
    </WrapText>
  );
};

export const Text7 = ({ text, icon, color }) => {
  return (
    <WrapText isIcon={icon ? true : false}>
      {icon}
      <Typography
        fontWeight={400}
        fontSize={"11px"}
        fontStyle={"normal"}
        lineHeight={"13px"}
        letterSpacing={"0.07pxx"}
        color={color || Theme.palette.text.grayDark}
      >
        {text}
      </Typography>
    </WrapText>
  );
};
export const Text8 = ({ text, icon, color, mTop, mLeft }) => {
  return (
    <WrapText isIcon={icon ? true : false}>
      {icon}
      <Typography
        marginLeft={mLeft}
        marginTop={mTop}
        fontWeight={300}
        fontSize={"11px"}
        fontStyle={"normal"}
        lineHeight={"13px"}
        letterSpacing={"0.07px"}
        color={color || Theme.palette.text.grayDark}
      >
        {text}
      </Typography>
    </WrapText>
  );
};

export const Text9 = ({ text, icon, color }) => {
  return (
    <WrapText isIcon={icon ? true : false}>
      {icon}
      <Typography
        fontWeight={400}
        fontSize={"13px"}
        fontStyle={"normal"}
        lineHeight={"18px"}
        letterSpacing={"0.078pxx"}
        color={color || Theme.palette.text.grayDark}
      >
        {text}
      </Typography>
    </WrapText>
  );
};

export const Text10 = ({ text, icon, color }) => {
  return (
    <WrapText isIcon={icon ? true : false}>
      {icon}
      <Typography
        fontWeight={400}
        fontSize={"8px"}
        fontStyle={"normal"}
        lineHeight={"16px"}
        letterSpacing={"-0.078pxx"}
        color={color || Theme.palette.text.grayDark}
      >
        {text}
      </Typography>
    </WrapText>
  );
};

const WrapText = ({ children, isIcon, onClick, loading }) => {
  return (
    <span
      onClick={!loading ? onClick : undefined}
      style={{
        display: "flex",
        alignItems: "center",
        gap: isIcon && "8px",
        cursor: loading ? "progress" : onClick ? "pointer" : "default",
      }}
    >
      {children}
    </span>
  );
};
